var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"fs-block",rawName:"v-fs-block"}],staticClass:"avatar-image"},[_c('div',{staticClass:"avatar-initials",class:['avatar-initials-' + _vm.initialsColor]},[_c('span',[_vm._v(_vm._s(_vm.initials))])])])}
var staticRenderFns = []

export { render, staticRenderFns }